// extracted by mini-css-extract-plugin
export var divider = "_kq-0";
export var systemMessage = "_kq-1";
export var systemMessageWrapper = "_kq-2";